// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1g2dc","footer":"ModalError_footer__3_fhw"};